import { useRoutes } from "react-router-dom";
import { authRoutes } from "./authRoutes";
import { userRoutes } from "./userRoutes";
import Login from "../pages/Auth/Login";

const PortalRoutes = () => {
  const allRoutes = [
    ...authRoutes,
    ...userRoutes,

    { path: "*", element: <Login /> },
  ];

  return useRoutes(allRoutes);
};

export default PortalRoutes;
